/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum ShipmentStatusType {

  requested = 'requested',
  request_rejected = 'request_rejected',
  cancelled = 'cancelled',
  before_pickup = 'before_pickup',
  in_progress = 'in_progress',
  partially_in_progress = 'partially_in_progress',
  unavailable_cargo = 'unavailable_cargo',
  returned_to_origin = 'returned_to_origin',
  partially_returned_to_origin = 'partially_returned_to_origin',
  in_transit = 'in_transit',
  partially_in_transit = 'partially_in_transit',
  transit_end = 'transit_end',
  partially_transit_end = 'partially_transit_end',
  return_to_origin = 'return_to_origin',
  partially_return_to_origin = 'partially_return_to_origin',
  lost = 'lost',
  partially_completed = 'partially_completed',
  mixed = 'mixed',
  mixed_with_failure = 'mixed_with_failure',
  completed = 'completed',
  completed_with_failure = 'completed_with_failure',
  undelivered = 'undelivered',
  documents_received = 'documents_received'
}

